module.exports = __webpack_public_path__ + "img/icon-sucrose.08da20c6.webp";